import { create } from 'apisauce'
import _ from 'lodash'
import { handlePromise, storage } from '@utils'
import store from '@store'
import { UserTypes } from '@store/reducers/User'
import AuthService from '@services/Auth'

const TWO_SECONDS_IN_MILISECONDS = 2000

const api = create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000
})

export const apiPublic = create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000
})

const refreshApi = create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000
})

api.addRequestTransform((request) => {
  const accessToken = storage.get('fb-onboarding-mozrest:token')
  if (!request['headers[public]']) {
    if (accessToken) request.headers.Authorization = `Bearer ${accessToken}`
  }
})

api.addAsyncResponseTransform(async (response) => {
  const { data, ok } = response

  if (!ok) {
    let errors = ''
    if (response && response.status === 401
        /* && data && ( data.error === 'invalid_grant' || data.error === 'access_denied' ) */) {
      const originalConfig = response.config
      const refreshtoken = storage.get('fb-onboarding-mozrest:refreshtoken')
      storage.clear('fb-onboarding-mozrest:refreshtoken')
      if (refreshtoken && !originalConfig._retry) {
        try {
          originalConfig._retry = true
          const refreshResponse = await refreshApi.post('/v2/token', {
            client_id: process.env.REACT_APP_CLIENT_ID,
            client_secret: process.env.REACT_APP_CLIENT_SECRET,
            grant_type: 'refresh_token',
            refresh_token: refreshtoken
          })
          storage.set('fb-onboarding-mozrest:token', refreshResponse.data.access_token)
          storage.set('fb-onboarding-mozrest:refreshtoken', refreshResponse.data.refresh_token)
          storage.set('fb-onboarding-mozrest:totalVenues', refreshResponse.data.totalVenues)
          const retryResponse = await api.any(originalConfig)
          Object.assign(response, retryResponse)
        } catch (error) {
          return store.dispatch({ type: UserTypes.LOGOUT_USER })
        }
      }

      if (!refreshtoken && !originalConfig._retry) {
        originalConfig._retry = true
        await new Promise((resolve) => setTimeout(resolve, TWO_SECONDS_IN_MILISECONDS))
        const retryResponse = await api.any(originalConfig)
        Object.assign(response, retryResponse)
      }

    }

    if (data) {
      if (data.form) {
        errors = {}
        _.map(data.form.errors, (error, key) => {
          if (!_.isEmpty(error)) {
            errors[key] = error.join('\n')
          }
        })
      } else if (data.errors) {
        if (_.isObject(data.errors) && !_.isArray(data.errors)) {
          errors = []
          _.map(data.errors, (error) => {
            if (_.isString(error)) errors.push(error)
            else if (_.isArray(errors)) errors.push(error.join('\n'))
          })
          errors = errors.join('\n')
        } else if (_.isArray(data.errors)) {
          errors = data.errors.join('\n')
        } else {
          errors = data.errors
        }
      } else if (data.message) errors = data.message
      else if (data.error_description) errors = data.error_description
      else errors = data
    }

    if (!errors || _.isEmpty(errors)) errors = 'apiError'
    if (response.config.method === 'get' && !_.isString(errors)) response.errors = 'apiError'
    else response.errors = errors
  }
})

export default api
